import React from 'react';
import { Navigate } from 'react-router-dom';
import ModelPerformance from '../../../../views/Meteorology/Fields/ModelPerformance';
import ModelPerformanceOverview from '../../../../views/Meteorology/Fields/ModelPerformance/Overview';
import ModelPerformanceDetailedView from '../../../../views/Meteorology/Fields/ModelPerformance/DetailedView';

const modelPerformanceRouter = {
  path: 'modelperformance',
  element: <ModelPerformance />,
  children: [
    { path: '', element: <Navigate to="overview" replace /> },
    { path: 'overview', element: <ModelPerformanceOverview /> },
    { path: 'detailedview', element: <ModelPerformanceDetailedView /> },
  ],
};

export default modelPerformanceRouter;
